import { Button, Grid2, Link, Stack, Typography } from '@mui/material';

import { AuthApi } from 'api';
import { InputField } from 'components/v2/input/InputField';
import InputPhoneNumber from 'components/v2/input/InputPhoneNumber';
import { useAcceptInvitation } from 'hooks/services/useAcceptInvitation';
import { useLocalization } from 'localization';
import { useWhitelabelSettings } from 'modules/branches/hooks';

const AcceptInvitation = () => {
  const { form, ui, action, apiState } = useAcceptInvitation();
  const { t } = useLocalization();
  const { data: whitelabel } = useWhitelabelSettings(AuthApi.isAuthenticated());

  if (!apiState.foundInvite || apiState.isError) {
    return (
      <Stack justifyContent="center" alignItems="center" height={'90vh'}>
        <Typography>{t('users.pages.acceptInvite.invalidOrExpiredLinkMessage')}</Typography>
      </Stack>
    );
  }

  return (
    <Stack my={2} gap={5}>
      <Link href="/" style={{ marginBottom: 10 }}>
        <img alt="logo" src={whitelabel?.logoUrl || '/logo.png'} width={140} />
      </Link>
      <Typography variant="h2">{ui.welcomeMessage}</Typography>
      <Grid2 container spacing={2} sx={{ width: { xs: '100%', lg: '50%' } }}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <InputField control={form.control} name="firstName" label={t('common.terms.firstName')} required />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <InputField control={form.control} name="lastName" label={t('common.terms.lastName')} required />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <InputPhoneNumber
            // value={form.watch('phoneNumber')}
            control={form.control}
            name={`phoneNumber`}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <InputField
            control={form.control}
            name="newPassword"
            label={t('common.terms.password')}
            required
            type="password"
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <InputField
            control={form.control}
            name="repeatPassword"
            label={t('common.terms.passwordConfirmation')}
            required
            type="password"
          />
        </Grid2>
      </Grid2>
      <Button
        variant="contained"
        size="large"
        sx={{ width: '50%' }}
        onClick={action.acceptInvitation}
        loading={apiState.isAccepting}
      >
        {t('users.pages.acceptInvite.submit')}
      </Button>
    </Stack>
  );
};

export default AcceptInvitation;
